import React from 'react';
import IntlMessages from 'util/IntlMessages';
import { Tag } from 'new-design/common/ui';

const STATUS_TAGS = {
  new: { color: 'primary', labelId: 'new' },
  improved: { color: 'default', labelId: 'improved' },
  fixed: { color: 'success', labelId: 'fixed' },
};

export const ReleaseNoteTag = ({ tag, className }) => {
  const status = STATUS_TAGS[tag];
  if (status) {
    return (
      <Tag color={status.color} uppercase className={className}>
        <IntlMessages id={status.labelId} />
      </Tag>
    );
  }
  return (
    <Tag uppercase className={className}>
      {tag}
    </Tag>
  );
};
